const InputDatepicker = ({ onClick, value, className, placeholder, name, disabled, onChange }) => {
  return (
    <input
      type="text"
      name={name}
      value={value}
      onClick={onClick}
      autoComplete="off"
      id={`date${name}`}
      onChange={onChange}
      disabled={disabled}
      className={className}
      placeholder={placeholder}
    />
  );
};

export default InputDatepicker;
